module.exports = __webpack_public_path__ + "img/6.70d0040b.jpg";